import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {CardsSortEnum} from "./cards-sort.enum";

@Injectable({
  providedIn: 'root'
})
export class CardsSortDialogService {
  public static sort: BehaviorSubject<CardsSortEnum> = new BehaviorSubject<CardsSortEnum>(CardsSortEnum.DEFAULT);
}

